import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconFireplace: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21 8c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h1v12H3c-.6 0-1 .4-1 1s.4 1 1 1h18c.6 0 1-.4 1-1s-.4-1-1-1h-1V8h1zM4 4h16v2H4V4zm8.2 12.9c.4.2.8.1 1.1-.2l.6-.6c.2.7.1 1.4-.2 1.9-.3.6-1 1-1.7 1-1.1 0-2-1-2-2.2 0-1 .7-1.7 1.4-2.5l.2-.2v1.8c0 .5.2.8.6 1zM18 20h-3.3c.3-.3.6-.6.8-1 .8-1.5.7-3.4-.4-5.1-.2-.3-.4-.4-.7-.5-.3 0-.6.1-.8.2-.1-1.3-.5-2.2-1.1-2.5-.2-.1-.5-.1-.8-.1-.3.1-.5.3-.6.6-.2.4-.6.8-1.1 1.3-.9.9-2 2-2 3.9 0 1.3.6 2.4 1.4 3.2H6V8h12v12z',
    })
  )
}
